module.exports = __webpack_public_path__ + "img/sedona-19.190d346a.png";